import axios from 'axios';

import { azureAuthentication } from 'utils/functions/authentication';

const { validateUser } = azureAuthentication();

const request = {
  get(headers, url, params) {
    const configOptions = {
      params,
      headers,
    };

    const apiCallPromis = axios.get(url, configOptions);
    return apiCallPromis;
  },

  post(headers, url, params) {
    const configOptions = {
      headers,
    };

    const apiCallPromis = axios.post(url, params, configOptions);
    return apiCallPromis;
  },

  put(headers, url, params) {
    const configOptions = {
      headers,
    };

    const apiCallPromis = axios.put(url, params, configOptions);
    return apiCallPromis;
  },

  patch(headers, url, params) {
    const configOptions = {
      headers,
    };

    const apiCallPromis = axios.patch(url, params, configOptions);
    return apiCallPromis;
  },
};

const wrap =
  method =>
  // eslint-disable-next-line consistent-return
  async (customHeaders = {}, replaceHeaders = false, ...props) => {
    const { isValidUser, appCookie } = await validateUser();

    if (isValidUser) {
      let headers = {
        authorization: `Bearer ${appCookie}`,
        ...customHeaders,
      };
      if (replaceHeaders) headers = customHeaders;

      return request[method](headers, ...props);
    }

    document.location.href = '/login';
  };

export const get = wrap('get');
export const post = wrap('post');
export const put = wrap('put');
export const patch = wrap('patch');
